import { supabase } from '../lib/supabase';

let _refreshPromise = null;

async function ensureFreshSession() {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) return null;

  const now = Math.floor(Date.now() / 1000);
  if (session.expires_at && session.expires_at - now < 60) {
    if (!_refreshPromise) {
      _refreshPromise = supabase.auth.refreshSession()
        .then(({ data }) => data.session)
        .catch(() => null)
        .finally(() => { _refreshPromise = null; });
    }
    return _refreshPromise;
  }

  return session;
}

async function callStockApi(action, params = {}) {
  const session = await ensureFreshSession();
  if (!session) {
    return { success: false, error: 'Not authenticated' };
  }

  const response = await supabase.functions.invoke('stock-api', {
    body: { action, ...params },
  });

  if (response.error) {
    return { success: false, error: 'Service unavailable' };
  }

  return { success: true, data: response.data };
}

export const getSubuserPackages = (tier) =>
  callStockApi('get-subuser-packages', { tier });

export const getSubuserPackageUsage = (packageId, tier) =>
  callStockApi('get-subuser-package-usage', { packageId, tier });

export const getBandwidthSummary = (tier) =>
  callStockApi('get-subuser-bandwidth-summary', { tier });

export const getStock = (type, country) =>
  callStockApi('get-stock', { type, country });

export const getSubuserIPs = () =>
  callStockApi('get-subuser-ips');

export const orderIPs = (type, country, amount, options = {}) =>
  callStockApi('order-subuser-ips', { type, country, amount, ...options });

export const extendIP = (proxyId, length) =>
  callStockApi('extend-subuser-ip', { proxyId, length });

export const rotateIP = (proxyId) =>
  callStockApi('rotate-subuser-ip', { proxyId });

export const updateIPSettings = (proxyId, settings) =>
  callStockApi('update-subuser-ip-settings', { proxyId, settings });

export const getAvailablePackages = () =>
  callStockApi('get-available-packages');

export const getSubuserInfo = () =>
  callStockApi('get-subuser');

export const updateSubuserPackage = (packageId, updates) =>
  callStockApi('update-subuser-package', { packageId, ...updates });

export default {
  getSubuserPackages,
  getSubuserPackageUsage,
  getBandwidthSummary,
  getStock,
  getSubuserIPs,
  orderIPs,
  extendIP,
  rotateIP,
  updateIPSettings,
  getAvailablePackages,
  getSubuserInfo,
  updateSubuserPackage,
};
